<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="8" offset-md="2">
                <v-card>
                    <v-card-text align="center">
                        <v-img class="elevation-0" src="../assets/logo-ratis.png" :max-width="logoMaxWidth"/>
                        <br/>
                        <h1>Willkommen im Mitarbeiter-Portal</h1>
                        <br/>
                        <p>
                            Um das Portal verwenden zu können, loggen Sie sich bitte ein.
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "home",
    computed: {
        logoMaxWidth() {
            if (this.$vuetify.breakpoint.xsOnly)
                return '80%';
            else if (this.$vuetify.breakpoint.smOnly)
                return '50%';

            return '40%';
        }
    }
};
</script>